<template>
  <div class="container-fluid container-fluid rounded-4 contenedor-principal">
    <div v-if="tramite" class="grid-observaciones px-1 mt-2">
      <tramites-energia-grid-detail :template-data="templateData"/>
    </div>
    <div v-else class="grid-observaciones px-1 mt-2">
      <operacion-grid-detail :template-data="templateData"/>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import TramitesEnergiaGridDetail from '@/components/tramites/TramitesEnergiaGridDetail.vue';
import OperacionGridDetail from '@/components/operaciones-energia/OperacionesEnergiaGridDetail.vue';
import { type DetailOperacionEnergiaModel, TipoSuministroTramiteEnergiaEnum } from '@/.shared/.api';

const props = defineProps({
  model: Object as () => DetailOperacionEnergiaModel,
  tramite: String as () => TipoSuministroTramiteEnergiaEnum,
  idTramite: String as () => String
});
  
const templateData = computed(() => {
  return {
    key: props.tramite ? props.idTramite : props.model?.Id,
    data: undefined
  };
})

</script>

<style lang="scss" scoped>

@import "@styles/_sharedvars.scss";

.grid-observaciones {
  flex-grow: 1; 
  max-height: 80%; 
  overflow: auto; 
}

.grid-observaciones :deep(.dx-datagrid) {
  max-height: 520px;
}
</style>